import {_utils, viewportChecker} from "../../utils/_utils.js";
import {_libs} from "../../utils/_libs.js";

/**
 * Stack slides — Lobby entrance / Pilot lounge / Snooze rooms / Conference room (Experience Gallery, TZ section 2).
 * The section is N screens tall and the stage is position: sticky (CSS — no GSAP pin, no pin-spacer).
 * Over the section's scroll each next slide slides in horizontally from the right and fully covers the previous one.
 * Scrubbed → reverses on scroll up. All breakpoints (user).
 */
export const stackSlides = () => {
    return new Promise((resolve) => {
        _utils.initSection('.stack-slides', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const stage = section.querySelector('.stack-slides__stage');
    const slides = [...section.querySelectorAll('.stack-slides__slide')];
    const incoming = slides.slice(1);
    if (!stage || !incoming.length) return;

    const tl = _libs._gsap({
        trigger: section,
        start: 'top top',
        end: 'bottom bottom', // section = N screens, stage sticky → (N - 1) screens of movement
        scrub: true,
        invalidateOnRefresh: true,
        //markers: true,
    });

    incoming.forEach((slide, i) => {
        // x: 0 drops the CSS pre-offset (translateX(100%)) so GSAP drives it with xPercent only
        tl.fromTo(slide, {x: 0, xPercent: 100}, {x: 0, xPercent: 0, ease: 'none', duration: 1}, i);
    });

    // ScrollTrigger positions are refreshed by _libs._gsap on resize / page-height changes
    _utils.rebuildComponentsOnResize(() => viewportChecker.all());
};
